import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toastSuccess, toastError, toastInfo } from '../../utils/alertHelper';

// Accept onMenuToggle as a prop!
function Nav({ onMenuToggle }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("defaultCountry");
    localStorage.removeItem("defaultState");
    localStorage.removeItem("defaultCity");
    localStorage.removeItem("user");
    localStorage.removeItem("planResponsibilities");
    toastSuccess("Logout successful");
    navigate("/"); // redirect to login
  };

  return (
    <div className="navbar-header" height="50px">
      <div className="navbar-brand-box d-flex align-items-left">
        <a href="#" className="logo">
          <span>
            <img src="/assets/images/sakhyam1.png" alt="" height="120" />
          </span>
          <i>
            <img src="/assets/images/sakhyam1.png" alt="" height="120" />
          </i>
        </a>
        <button
          type="button"
          className="btn btn-sm mr-2 d-lg-none px-1 font-size-10 header-item waves-effect waves-dark mt-3"
          id="vertical-menu-btn"
          onClick={onMenuToggle} // <-- This works now!
        >
          <i className="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div className="d-flex align-items-center">
        <div className="dropdown d-inline-block ml-2">
           <button
                      type="button"
                      className="btn header-item waves-effect waves-light"
                      id="page-header-user-dropdown"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    > 
            <img className="rounded-circle header-profile-user" src="" alt="Header Avatar" />
            <i className="mdi mdi-chevron-down d-none d-sm-inline-block"></i>
          </button>
          <div className="dropdown-menu dropdown-menu-right">
            <a className="dropdown-item d-flex align-items-center justify-content-between" href="">
              <span>Profile</span>
            </a>
            <a className="dropdown-item d-flex align-items-center justify-content-between" href="">
              <span>Change Password</span>
            </a>
            <a
              href=""
              onClick={handleLogout}
              className="dropdown-item d-flex align-items-center justify-content-between"
            >
              <span>Log Out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;